import { gql } from "@apollo/client";

export const GET_TOP_SPEND_PLATFORMS = gql`
  query GetTopSpendPlatforms {
    me {
      topSpendPlatforms
    }
  }
`;
